module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo14-e6820a78ba7a339ac5a4af57cbe92a93.jpg";